import HeroSection from './HeroSection/HeroSection';
import Features from './Features/Features';
import Pricing from './Pricing/Pricing';
import { Routes, Route, useLocation } from 'react-router-dom';
import InternachiPricing from './Pricing/InterNachiPricing';
import AboutUs from './AboutUs/AboutUs';
import Download from './Download/Download';
import BlueCurve from '../../assets/images/blue-curve-2x.png';

import React, { useEffect } from 'react';

interface MainContentProps {
  isMobile: boolean;
  isTablet: boolean;
  setToastMessage: (message: string) => void;
  setShowToast: (showToast: boolean) => void;
}

const MainContent: React.FC<MainContentProps> = ({
  isMobile,
  isTablet,
  setToastMessage,
  setShowToast,
}) => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash fragment scrolling on mount and route changes
    const scrollToHashElement = () => {
      const hash = window.location.hash;
      if (hash) {
        // Extract just the hash part, removing any query parameters that might be attached
        const hashPart = hash.split('?')[0];
        const elementId = hashPart.substring(1); // Remove the # symbol
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    // Use longer timeout for mobile devices to ensure DOM is fully ready
    const timeout = isMobile ? 300 : 100;
    setTimeout(scrollToHashElement, timeout);
  }, [location, isMobile]);

  return (
    <main className="main-content">
      <HeroSection
        setToastMessage={setToastMessage}
        setShowToast={setShowToast}
      />
      <div className="blue-curve-wrapper">
        <img src={BlueCurve} alt="Decorative blue curve" />
      </div>
      <Features
        isMobile={isMobile}
        isTablet={isTablet}
        setToastMessage={setToastMessage}
        setShowToast={setShowToast}
      />
      <div className="blue-curve-wrapper">
        <img src={BlueCurve} alt="Decorative blue curve" />
      </div>
      <Routes>
        <Route path="/" element={<Pricing />} />
        <Route
          path="/InterNACHI-discount-ji394su3pa7"
          element={<InternachiPricing />}
        />
      </Routes>
      <Download />
      <AboutUs />
    </main>
  );
};

export default MainContent;
